module.exports = __webpack_public_path__ + "img/111.2c891dc5.jpg";